import type { FragmentOf } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { useEffect } from "react"
import { FlowActions } from "../../stores/flowStore"

export const useSetReceiptStatusFragment = graphql(`
  fragment useSetReceiptStatus on Receipt {
    status
  }
`)

export function useSetReceiptStatus(
  receiptKey: FragmentOf<typeof useSetReceiptStatusFragment> | undefined,
) {
  const receipt = readFragment(useSetReceiptStatusFragment, receiptKey)

  useEffect(
    function setReceiptStatusInFlowStore() {
      FlowActions.setReceiptStatus(receipt?.status ?? "PENDING")
      if (receipt?.status === "SUCCESS") {
        FlowActions.onSuccess()
      }
    },
    [receipt],
  )
}
